/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Typography } from '@saviynt/design-system';

import { TOKENS } from '../../../../shared/constants';

export const TextCell = ({
  text = null,
  lineLimit = 1,
  className = '',
}: {
  text?: string | number | null;
  lineLimit?: number;
  className?: string;
}) => (
  <Typography
    kind='body2'
    desktop='body2-d'
    mobile='body2-d'
    color={TOKENS.CF_SEC_BLD}
    lineLimit={lineLimit}
    tooltipConfigs={{ placement: 'left' }}
    className={className}>
    {text ?? '-'}
  </Typography>
);

export const TextBoldCell = ({
  text = null,
}: {
  text: string | number | null;
}) => (
  <Typography
    kind='body2-bold'
    desktop='body2-bold-d'
    mobile='body2-bold-d'
    color={TOKENS.CF_SEC_BLD}
    lineLimit={1}
    tooltipConfigs={{ placement: 'left' }}>
    {text ?? '-'}
  </Typography>
);
